import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SecondFactorEnrollmentFailedAction = {
	type: 'SECOND_FACTOR_ENROLLMENT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SecondFactorEnrollmentFailedAction => ({
	type: 'SECOND_FACTOR_ENROLLMENT_FAILED',
	payload,
});
